<template>
  <div class="mobile-page">
    <div class="header-box">
      <img
        class="header-logo"
        src="https://www-static.qbox.me/sem/pili-live-1001/source/img/header-logo-mobile.png"
        alt=""
      />
      <div class="icons-box">
        <img
          @click="showPopup = true"
          v-if="!showPopup"
          class="header-icon"
          src="https://www-static.qbox.me/sem/pili-live-1001/source/img/header-2.png"
          alt=""
        />
        <van-icon
          @click="showPopup = false"
          v-if="showPopup"
          size=".48rem"
          color="#333"
          class="header-icon"
          name="cross"
        />
      </div>
    </div>
    <div class="banner"></div>
    <div class="labels">
      <div class="label-item" v-for="(item, i) in labels" :key="i">
        <img :src="item.icon" alt="" />
        <span>{{ item.title }}</span>
      </div>
    </div>
    <div class="versionModule">
      <span class="module-title">多版本满足不同需求，咨询抢购</span>
      <div class="typeList">
        <div class="versionItem" v-for="(item, i) in versionlist" :key="i">
          <div class="header" :class="'headerColor' + i">
            <div class="titleBox">
              <span class="title">{{ item.title }}</span>
              <div class="subtitle">
                <span class="subtitle1">{{ item.subtitle1 }}</span>
                <span class="subtitle2">{{ item.subtitle2 }}</span>
              </div>
            </div>
          </div>
          <div class="item-body">
            <div class="contentList">
              <div
                class="contentItem"
                v-for="(obj, index) in item.contents"
                :key="index"
              >
                <div class="right-icon-box" :class="'icon-color' + i">
                  <img
                    class="right-icon"
                    src="https://www-static.qbox.me/sem/pili-live-1001/source/img/right-icon.png"
                    alt=""
                  />
                </div>
                <div
                  :class="
                    index == 2
                      ? 'content-text-special special-color' + i
                      : 'content-text'
                  "
                >
                  {{ obj }}
                </div>
              </div>
            </div>
            <div class="price-box">
              <div class="true-price">
                <span class="money-type">¥</span>
                <span class="price-number">{{ item.price1 }}</span>
                <span class="text-unit">/年</span>
              </div>
              <div class="fake-price">
                {{ "市场价：" + item.price2 + "/年" }}
              </div>
            </div>
            <div
              @click="toClient()"
              class="item-button"
              :class="'button-color' + i"
            >
              购买咨询
            </div>
          </div>
          <img
            class="specialIcon"
            v-if="i == 2"
            :src="item.specialIcon"
            alt=""
          />
        </div>
      </div>
      <span class="module-tips"
        >*API对接、系统打通、商城打通、私有化部署等需求，相关报价请咨询客服</span
      >
    </div>
    <div class="prosModule">
      <div class="header">
        <span class="title">打通私域直播全流程</span>
      </div>
      <div class="pros-body">
        <van-collapse v-model="activeNames">
          <van-collapse-item
            class="pros-item"
            :name="i"
            :title="item.title"
            v-for="(item, i) in prosDetailList"
            :key="i"
          >
            <div class="text-contents">
              <div
                class="content-item"
                v-for="(newStr, k) in item.contents"
                :key="k"
              >
                <div class="grey-point"></div>
                <div class="text">{{ newStr }}</div>
              </div>
            </div>
            <div @click="toRegister()" class="text-button">免费试用</div>
            <div class="img-box">
              <img :src="item.img" alt="" />
            </div>
            <!-- 代码是写出来给人看的，附带能在机器上运行。 -->
          </van-collapse-item>
        </van-collapse>
        <div></div>
      </div>
    </div>
    <div class="sceneModule">
      <div class="header">
        <span class="title">覆盖直播业务全场景</span>
      </div>
      <div class="scene-body">
        <div class="scene-box">
          <div class="scene-item" v-for="(item, i) in scene" :key="i">
            <img :src="item.img" alt="" />
            <span>{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="userModule">
      <div class="header">
        <span class="title">他们都在用七牛云</span>
        <span class="subtitle">（*排名不分先后顺序）</span>
      </div>
      <div class="user-body">
        <div class="user-box">
          <div class="user-item" v-for="i in 20" :key="i">
            <img
              :src="'https://www-static.qbox.me/sem/pili-live-1001/source/img/user-' + (i - 1) + '.jpg'"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="footerModule">
      <div class="footer-images">
        <div class="content-box">
          <span>免费领取价值 999 元试用资格</span>
          <div @click="toClient()" class="footer-button">立即领取</div>
        </div>
      </div>
      <div class="bottom-text">
        <div class="copyright-box">
          <img
            @click="toQiniuOfficial()"
            src="https://www-static.qbox.me/sem/pili-live-1001/source/img/qiniu_logo-1.png"
            alt=""
          />
          <div class="text-box">
            <span>Copyright © 2011-2023 Qiniu Cloud.</span>
            <span>产品及服务咨询：400-808-9176 转 1</span>
          </div>
        </div>
        <div class="other-text">
          <span @click="toBeian()">沪公网安备31011502000961号</span>
          <span @click="toBeian()">沪ICP备11037377号-5</span>
        </div>
      </div>
    </div>
    <div @click="toClient()" class="footer-box">
      免费领取价值 999 元试用资格
    </div>
    <van-popup
      v-model="showPopup"
      position="top"
      style="
        margin-top: 1.04rem;
        display: flex;
        flex-direction: column;
        width: calc(100% - 0.64rem);
      "
      :style="{ padding: '.32rem' }"
    >
      <van-button
        style="
          margin-bottom: 0.32rem;
          background: #07beff;
          border-color: #07beff;
          color: #fff;
          text-align: center;
          height: 0.64rem;
          font-size: 0.28rem;
          line-height: 0.64rem;
        "
        @click="toRegister()"
      >
        免费注册
      </van-button>
      <van-button
        style="
          background: #fff;
          border-color: #07beff;
          color: #07beff;
          text-align: center;
          height: 0.64rem;
          font-size: 0.28rem;
          line-height: 0.64rem;
        "
        @click="login()"
      >
        登录
      </van-button>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "mobilePage",
  props: {
    msg: String,
  },
  data() {
    return {
      showPopup: false,
      activeNames: [],
      labels: [
        {
          icon: "https://www-static.qbox.me/sem/pili-live-1001/source/img/save-money.jpg",
          title: "省钱",
        },
        {
          icon: "https://www-static.qbox.me/sem/pili-live-1001/source/img/easy-to-use.jpg",
          title: "易用",
        },
        {
          icon: "https://www-static.qbox.me/sem/pili-live-1001/source/img/stable.jpg",
          title: "稳定",
        },
        {
          icon: "https://www-static.qbox.me/sem/pili-live-1001/source/img/exclusive.jpg",
          title: "专属",
        },
      ],
      versionlist: [
        {
          title: "基础版",
          subtitle1: "超低启动成本",
          subtitle2: "适用于初步尝试直播推广",
          contents: [
            "通用的直播功能",
            "支持推流、OBS、网页、APP等主流直播形式，同时开播场次不限",
            "包含20,000GB流量",
          ],
          price1: "3899",
          price2: "5198",
          specialIcon: "",
        },
        {
          title: "进阶版",
          subtitle1: "性价比之王",
          subtitle2: "适用于高速成长型企业",
          contents: [
            "提供通用功能+进阶营销功能",
            "多种互动工具，增强您的用户粘性，降低营销投入，提高转化率",
            "包含40,000GB流量",
          ],
          price1: "7599",
          price2: "10098",
          specialIcon: "",
        },
        {
          title: "旗舰版",
          subtitle1: "功能齐全，价值典范",
          subtitle2: "适用于大中型企业专属直播",
          contents: [
            "包含全覆盖的直播功能",
            "支持定制化品牌形象塑造，打破企业业务边界，满足深度使用需求",
            "包含90,000GB流量",
          ],
          price1: "16999",
          price2: "45298",
          specialIcon: "https://www-static.qbox.me/sem/pili-live-1001/source/img/specialIcon.png",
        },
      ],
      scene: [
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/scene-1.png",
          text: "营销直播",
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/scene-2.png",
          text: "培训直播",
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/scene-3.png",
          text: "活动直播",
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/scene-4.png",
          text: "会议直播",
        },
      ],
      prosDetailList: [
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/pro-1.png",
          title: "方便快捷",
          contents: [
            "无需开发，开箱即用，一天上线，PC、手机、微信端等全终端覆盖",
            "操作界面直观、一键嵌入自有公众号、门户、小程序、APP，快速上手，一天即会",
            "支持PC网页、APP、OBS推流等近10种直播方式，一键开播，无需下载任何插件",
          ],
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/pro-2.png",
          title: "分享裂变",
          contents: [
            "支持推流分享至视频号、微博、抖音、B站等各大主流平台播放，实现裂变式引流",
            "支持通过微信、公众号、短信等渠道触达用户，激活企业私域流量",
            "支持使用邀请卡、分享有礼等功能促进用户分享直播，达成私域自裂变",
          ],
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/pro-3.png",
          title: "用户留存",
          contents: [
            "互动聊天、红包抽奖、点赞送礼等多种营销功能，活跃直播间气氛，提高用户参与度",
            "在线问答、匿名聊天、客服私聊，鼓励用户参与讨论并实时回复，提升参与价值感",
            "支持网页、移动、APP等多终端直播观看，提高用户便利性与体验感，增加用户留存",
          ],
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/pro-4.png",
          title: "数据分析",
          contents: [
            "支持竖屏直播，迎合用户观看习惯，沉浸式体验",
            "直播间可对接企业自有商城，上架推送商品卡片，观众边看边买，加快购买决策",
            "支持多样化的直播形式，可通过产品演示、知识培训的方式吸引用户，引导购买",
          ],
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/pro-5.png",
          title: "方便快捷",
          contents: [
            "多维度用户画像、直播观看统计，帮助企业复盘直播效果",
            "精细化的数据报告，帮助企业快速了解观众画像，实现精准转化",
            "开放标准接口，可与企业自有体系打通，实现多平台、全链路数据同步",
          ],
        },
      ],
    };
  },
  methods: {
    toQiniuOfficial() {
      window.open("https://www.qiniu.com/");
    },
    toQiniuDetail() {
      window.open("https://www.qiniu.com/company");
    },
    login() {
      window.open("https://s.qiniu.com/uaANNn");
    },
    toRegister() {
      window.open("https://portal.qiniu.com/signup?invitation_type=700&invitation_key=L3IyafzJe97eD9iDke5CFmXK&redirect_url=https://s.qiniu.com/uaANNn")
    },
    toClient() {
      window.open(
        "https://affim.baidu.com/unique_53498961/chat?siteId=20774082&userId=53498961&siteToken=35708c2ed9714876a5578566862942da&cp=https%3A%2F%2Fwww.qiniu.com%2Fsem%2Fpili-live-1001%2Findex.html&cr=&cw=%E4%B8%83%E7%89%9B%E5%AE%98%E7%BD%91%E4%BC%81%E4%B8%9A%E7%9B%B4%E6%92%AD%E8%AF%A6%E6%83%85%E9%A1%B5"
      );
    },
    toBeian() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.mobile-page {
  width: 100vw;
  display: flex;
  padding-bottom: 0.84rem;
  .header-box {
    z-index: 3000;
    position: relative;
    width: calc(100% - 0.48rem);
    padding: 0 0.24rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 1.04rem;
    background: #ffffff;
    box-shadow: 0px 1px 0px 0px #eeeeee;
    .header-logo {
      width: 1.56rem;
      height: 0.4rem;
    }
    .icons-box {
      height: 100%;
      display: flex;
      display: row;
      align-items: center;
      .header-icon {
        width: 0.48rem;
        height: 0.48rem;
      }
    }
  }
  .banner {
    width: 100%;
    height: 5rem;
    background-position: center;
    background-image: url("https://www-static.qbox.me/sem/pili-live-1001/source/img/banner-mobile.png");
    background-repeat: no-repeat;
    background-size: cover;
  }
  .labels {
    width: calc(100% - 0.62rem);
    padding: 0 0.31rem;
    height: 1.6rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: #ffffff;
    .label-item {
      padding: 0.28rem 0 0.2rem 0;
      width: 1.6rem;
      height: 1.12rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      img {
        width: 0.52rem;
        height: 0.52rem;
      }
      span {
        font-family: PingFang SC;
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.4rem;
        letter-spacing: 0;
        text-align: center;
        color: #333333;
      }
    }
  }
  .versionModule {
    width: calc(100% - 0.64rem);
    padding: 0.56rem 0.32rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    .module-title {
      height: 0.6rem;
      font-family: PingFang SC;
      font-size: 0.4rem;
      font-weight: 500;
      line-height: 0.6rem;
      letter-spacing: 0px;
      text-align: center;
      color: #333;
      margin-bottom: 0.4rem;
    }
    .typeList {
      display: flex;
      flex-direction: column;
      width: 100%;
      .versionItem {
        display: flex;
        flex-direction: column;
        position: relative;
        box-shadow: 0px 0.06rem 0.48rem 0px #0000000f;
        border-radius: 0.18rem;
        margin-bottom: 0.32rem;
        .headerColor0 {
          background-image: url("https://www-static.qbox.me/sem/pili-live-1001/source/img/version-1.png");
        }
        .headerColor1 {
          background-image: url("https://www-static.qbox.me/sem/pili-live-1001/source/img/version-2.png");
        }
        .headerColor2 {
          background-image: url("https://www-static.qbox.me/sem/pili-live-1001/source/img/version-3.png");
        }
        .header {
          width: 100%;
          height: 2.36rem;
          display: flex;
          flex-direction: column;
          border-radius: 0.18rem;
                    background-repeat: no-repeat;
              background-size: cover;
              background-position: right;
          .titleBox {
            margin-top: 0.48rem;
            margin-left: 0.54rem;
            display: flex;
            flex-direction: column;
            .title {
              font-family: Alibaba PuHuiTi;
              font-size: 0.46rem;
              font-weight: 700;
              line-height: 0.54rem;
              letter-spacing: 0px;
              margin-bottom: 0.18rem;
              height: 0.54rem;
              color: #333;
            }
            .subtitle {
              font-family: PingFang SC;
              font-size: 0.24rem;
              font-weight: 400;
              line-height: 0.36rem;
              letter-spacing: 0px;
              height: 0.72rem;
              display: flex;
              flex-direction: column;
              color: #666666;
              span {
                height: 0.36rem;
              }
            }
          }
        }
        .item-body {
          // width: 100%;
          border-radius: 0.18rem;
          height: 4.56rem;
          background: #fff;
          display: flex;
          flex-direction: column;
          padding: 0 0.54rem;
          .contentList {
            display: flex;
            flex-direction: column;
            height: 1.72rem;
            justify-content: space-between;
            padding-bottom: 0.32rem;
            border-bottom: 1px solid #e5e5e5;
            .contentItem {
              display: flex;
              flex-direction: row;
              align-items: center;
              font-family: PingFang SC;
              line-height: 0.34rem;
              letter-spacing: 0px;
              text-align: left;
              .right-icon-box {
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 0.2rem;
                margin-right: 0.16rem;
                display: flex;
                .right-icon {
                  width: 0.16rem;
                  height: 0.12rem;
                  margin: auto;
                }
              }
              .icon-color0 {
                background: linear-gradient(180deg, #8994d0 0%, #769ddb 100%);
              }
              .icon-color1 {
                background: linear-gradient(180deg, #1b6ae6 0%, #388ceb 100%);
              }
              .icon-color2 {
                background: linear-gradient(180deg, #ff7a25 0%, #ffa029 100%);
              }
              .content-text {
                font-size: 0.22rem;
                max-width: 5.34rem;
                font-weight: 400;
                color: #666;
              }
              .content-text-special {
                font-size: 0.26rem;
                font-weight: 600;
                -webkit-background-clip: text;
                color: transparent;
              }
              .special-color0 {
                background-image: linear-gradient(
                  180deg,
                  #8b92ce 0%,
                  #719edd 100%
                );
              }
              .special-color1 {
                background-image: linear-gradient(
                  180deg,
                  #1663e4 0%,
                  #3e94ec 100%
                );
              }
              .special-color2 {
                background-image: linear-gradient(
                  180deg,
                  #ff7424 0%,
                  #ffa829 100%
                );
              }
            }
          }
          .price-box {
            height: 0.4rem;
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            font-family: PingFang SC;
            font-size: 0.22rem;
            font-weight: 400;
            line-height: 0.22rem;
            letter-spacing: 0px;
            color: #4e5969;
            margin: 0.4rem 0;
            .true-price {
              padding-right: 0.36rem;
              color: #333;
              height: 0.4rem;
              display: flex;
              flex-direction: row;
              align-items: flex-end;
              .money-type {
                height: 0.22rem;
              }
              .price-number {
                font-size: 0.48rem;
                font-weight: 600;
                height: 0.4rem;
                line-height: 0.4rem;
                letter-spacing: 0.05px;
              }
              .text-unit {
                font-size: 0.18rem;
                height: 0.18rem;
                line-height: 0.18rem;
                color: #4e5969;
              }
            }
            .fake-price {
              height: 0.22rem;
              text-decoration: line-through;
            }
          }
          .item-button {
            width: 100%;
            height: .8rem;
            border-radius: .44rem;
            line-height: .8rem;
            text-align: center;
            font-family: PingFang SC;
            font-size: .32rem;
            font-weight: 500;
            letter-spacing: 0px;
            color: #fff;
          }
          .button-color0 {
            background: linear-gradient(
              90.78deg,
              #bbcce4 0%,
              #8b92ce 100%,
              #8b92ce 100%
            );
          }
          .button-color1 {
            background: linear-gradient(90.78deg, #46a7fb 0%, #337fff 100%),
              linear-gradient(
                0deg,
                rgba(255, 255, 255, 0.2),
                rgba(255, 255, 255, 0.2)
              );
          }
          .button-color2 {
            background: linear-gradient(90.78deg, #f9b34c 0%, #ff7628 100%);
          }
        }
        .icon {
          position: absolute;
          width: 1.84rem;
          height: 1.88rem;
          top: 0.24rem;
          right: 0.24rem;
        }
        .specialIcon {
          width: 2.92rem;
          height: 0.46rem;
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -1.46rem;
        }
      }
    }
    .module-tips {
      margin-top: 0.08rem;
      font-family: PingFang SC;
      font-size: 0.24rem;
      font-weight: 400;
      line-height: 0.36rem;
      letter-spacing: 0px;
      color: #969799;
      text-align: center;
    }
  }
  .prosModule {
    padding: 0.54rem 0.32rem;
    width: calc(100% - 0.64rem);
    background: #f8f9fe;
    .header {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 0.4rem;
      .title {
        font-size: 0.4rem;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 0.6rem;
        letter-spacing: 0px;
      }
    }
    .pros-body {
      width: 100%;
      :deep(.van-collapse-item--border:after){
          border-top: 0;
        }
      .pros-item {
        margin-bottom: 0.24rem;
        border: 1px solid #e5edf4;
        box-shadow: 0px 10px 20px 0px #00000005;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 4px;
        :deep(.van-cell) {
          display: flex;
          position: relative;
          display: -webkit-box;
          display: -webkit-flex;
          display: flex;
          box-sizing: border-box;
          width: 100%;
          padding: 0.24rem 0.32rem;
          overflow: hidden;
          color: #333333;
          font-family: PingFang SC;
          font-size: 0.32rem;
          font-weight: 500;
          line-height: 0.48rem;
          letter-spacing: 0px;
          border-radius: 4px;
          text-align: left;
        }
        :deep(.van-cell::after) {
          border-bottom: 0;
        }
        :deep(.van-collapse-item__wrapper) {
          width: 100%;
        }
        :deep(.van-collapse-item__content) {
          font-family: PingFang SC;
          font-size: 0.28rem;
          font-weight: 400;
          line-height: 0.44rem;
          letter-spacing: 0px;
          text-align: left;
          padding: 0 0.32rem 0.32rem 0.32rem;
          border-radius: 4px;
          color: #666;
        }
        .text-contents {
          margin-bottom: 0.08rem;
          .content-item {
            display: flex;
            flex-direction: row;
            margin-bottom: 0.16rem;
            .grey-point {
              width: 0.12rem;
              height: 0.12rem;
              margin: auto 0;
              background: #c7cede;
              border-radius: 50%;
              margin-right: 0.16rem;
            }
            .text {
              max-width: 5.9rem;
            }
          }
        }
        .text-button {
          color: #187bff;
          text-decoration: underline;
          margin-bottom: 0.32rem;
        }
        .img-box {
          width: 6.22rem;
          height: 4.98rem;
          border-radius: 4px;
          background: #f8f9fe;
          position: relative;
          display: flex;
          img {
            //   width: 6.46rem;
            //     height: 5.4rem;
            //     top: -.26rem;
            //     left: -.12rem;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .sceneModule {
    width: calc(100% - 0.48rem);
    padding: 0.56rem 0.24rem 0.24rem 0.24rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 0.24rem;
      .title {
        font-size: 0.4rem;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 0.6rem;
        letter-spacing: 0px;
      }
    }
    .scene-body {
      width: 100%;
      display: flex;
      .scene-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .scene-item {
          width: 3.3rem;
          height: 2.58rem;
          margin: 0.08rem;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          padding: 0.16rem 0 0.24rem 0;
          justify-content: space-between;
          align-items: center;
          background: #f6f9ff;
          img {
            width: 2.98rem;
            height: 2.06rem;
            border-radius: 4px;
          }
          span {
            font-family: PingFang SC;
            font-size: .24rem;
            font-weight: 500;
            line-height: .36rem;
            letter-spacing: 0px;
          }
        }
      }
    }
  }
  .userModule {
    width: calc(100% - 0.64rem);
    padding: 0.56rem 0.32rem;
    .header {
      width: 100%;
      height: 1.04rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      justify-content: space-between;
      //   margin-bottom: 44px;
      font-family: PingFang SC;
      letter-spacing: 0px;
      margin-bottom: 0.4rem;
      .title {
        font-size: 0.4rem;
        font-weight: 500;
        line-height: 0.6rem;
        color: #333;
      }
      .subtitle {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.36rem;
        color: #6b6b6b;
      }
    }
    .user-body {
      width: 100%;
      overflow: auto;
      .user-box {
        width: 15.2rem;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .user-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          background: linear-gradient(0deg, #e5edf4, #e5edf4),
            linear-gradient(0deg, #ffffff, #ffffff);
          border: 1px solid #e5edf4;
          box-shadow: 0px 0.1rem 0.2rem 0px #00000005;
          width: 2.8rem;
          height: 1.04rem;
          margin: 0.1rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .footerModule {
    width: 100%;
    .footer-images {
      width: 100%;
      height: 3.2rem;
      background-position: center;
      background-image: url("https://www-static.qbox.me/sem/pili-live-1001/source/img/footer-mobile.png");
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: PingFang SC;
      letter-spacing: 0em;
      color: #fff;
      .content-box {
        height: calc(100% - 1.4rem);
        padding: 0.7rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        span {
          font-weight: 500;
          font-size: 0.4rem;
          line-height: 0.6rem;
        }
        .footer-button {
          font-size: 0.28rem;
          width: 2.4rem;
          height: 0.8rem;
          text-align: center;
          font-weight: 600;
          border-radius: 26px;
          line-height: 0.8rem;
          background: linear-gradient(90deg, #f9b34c 0%, #ff7729 100%);
          box-shadow: 0px 2px 4px 0px #ffffff4d inset;
          box-shadow: 0px 4px 20px 0px #180a0026;
        }
      }
    }
    .bottom-text {
      width: 100%;
      padding: 0.56rem 0;
      height: 2.06rem;
      background: #2c3138;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      z-index: 1;
      .copyright-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 1.54rem;
        img {
          width: 1.76rem;
          height: 0.5rem;
        }
        .text-box {
          display: flex;
          flex-direction: column;
          height: 0.8rem;
          justify-content: space-between;
          align-items: center;
          text-align: center;
          span {
            font-family: PingFang SC;
            font-size: 0.24rem;
            font-weight: 400;
            line-height: 0.36rem;
            letter-spacing: 0em;
            color: #fff;
          }
        }
      }
      .other-text {
        width: 6rem;
        height: 0.36rem;
        opacity: 0.7px;
        color: #eeeeee;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-family: PingFang SC;
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.36rem;
        letter-spacing: 0em;
        text-align: text;
      }
    }
  }
  .footer-box {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 0.84rem;
    background: linear-gradient(90.78deg, #46a7fb 0%, #337fff 100%);
    font-family: PingFang SC;
    font-size: 0.28rem;
    font-weight: 600;
    line-height: 0.84rem;
    letter-spacing: 0em;
    text-align: center;
    color: #ffffff;
  }
}
</style>
